/**
 * @name isCssColorString
 * @description Checks if a string is a CSS compatible colour
 *
 * Matches hexadecimal colours between 3 and 8 characters long,
 * rgb, rgba, hsl and hsla colours
 */
export const isCssColorString = (str: string) =>
  /^(?:#[0-9a-f]{3,8}|rgba?\(|hsla?\()/i.test(str);
